import { FC } from "react";
import { classifyRI } from "@leopart/calc";
import { User } from "@phosphor-icons/react";
import styles from "./PlayerCard.module.scss";

interface PlayerCardProps {
  athleteId: string;
  name: string;
  shirtNumber?: number;
  roleLabel?: string;
  riScore?: number;
  isSelected?: boolean;
  onClick?: () => void;
  compact?: boolean;
}

/**
 * Card giocatore stile "FIFA sobrio".
 * Spec: LEOPART_ProgrammazioneCampo_Spec_v1.1.1.md righe 666-683.
 * Palette brand: #063444 / #ffd15a / #00212c.
 * Card compatta circa 80x80px, no glitter/gradienti.
 */
const PlayerCard: FC<PlayerCardProps> = ({
  name,
  shirtNumber,
  roleLabel,
  riScore,
  isSelected = false,
  onClick,
  compact = false,
}) => {
  const getRiBadgeColor = (score?: number) => {
    if (score === undefined) return styles.riBadgeDefault;
    // Soglie centralizzate in @leopart/calc (classifyRI): fonte unica.
    switch (classifyRI(score)) {
      case 'good':
        return styles.riBadgeGood;
      case 'normal':
        return styles.riBadgeNormal;
      case 'warning':
        return styles.riBadgeWarning;
      default:
        return styles.riBadgeCritical;
    }
  };

  return (
    <button
      className={[
        styles.card,
        isSelected ? styles.cardSelected : "",
        compact ? styles.cardCompact : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={onClick}
      type="button"
    >
      <div className={styles.avatarWrap}>
        <User size={compact ? 20 : 24} weight="duotone" color="#4d4d4d" />
        {riScore !== undefined && (
          <span className={[styles.riBadge, getRiBadgeColor(riScore)].join(" ")}>
            {Math.round(riScore)}
          </span>
        )}
      </div>

      <div className={styles.info}>
        <p className={styles.name}>{name}</p>
        {shirtNumber !== undefined && (
          <p className={styles.shirt}>#{shirtNumber}</p>
        )}
        {roleLabel && <p className={styles.role}>{roleLabel}</p>}
      </div>
    </button>
  );
};

export default PlayerCard;
